import React, { Component } from 'react';

import moment from 'moment';

import { Cell, ActionCell } from 'components/Table';
import Reactable, {Table, Thead, Th, Tr, Td} from 'reactable';
import { keyedObjToArr, formatPrice, getTimestampToDate } from '../util';

import 'sass/components/table.scss';
import 'sass/components/order-list';


export class AvatarCell extends Component {
    render () {
        let name = this.props.item.status ?  this.props.item.status
            .split(' ')
            .map( (word)=> {
                return word.toUpperCase().charAt(0);
            }).join('').substring(0,1)  : '';

        return (
			<Cell {...this.props} value={this.props.value}>
				<div className={`avatar ${this.props.item.status}`}>{name !== '' ? name : ' '}</div>
			</Cell>
        );
    }
}

export class CustomerCell extends Component {
	render () {
		let price = this.props.item.total;

		return(<Cell>
			{this.props.customer ?
				(<div className="data normal-size bold">{this.props.customer.name ? this.props.customer.name : 'customer name missing!'}</div>)
				: false}
			{price ? (<div className="data success-color">{formatPrice(price)}</div>) : false}
		</Cell>);
	}
}

export class ProductsCell extends Component {
	render () {
		let products = keyedObjToArr(this.props.item.products);
		return(<Cell className="">
			<ul>
				{products.map( (product, index)=> {
					return(
						<li key={index} className="data light-text-color">
							<span className="text-color">{product.name}</span>
							<span className="kill-sm"> for {product.studentCount} Students</span>
							<span className="kill-xlg"> at {formatPrice(product.price)} Per Student</span>
						</li>
					);
				})}
			</ul>
		</Cell>);
	}
}

export class StatusCell extends Component {

	render () {
		let startDate = this.props.item.startDate ? getTimestampToDate(this.props.item.startDate).format('MM/DD/YYYY') : '';
		let endDate = this.props.item.endDate ? getTimestampToDate(this.props.item.endDate).format('MM/DD/YYYY') : '';
		let status = this.props.item.status ? this.props.item.status.charAt(0).toUpperCase() + this.props.item.status.slice(1) : '';

		return(<Cell {...this.props}>
			<div className="data">{status} {startDate}</div>
			<div className="light-text-color data"> {endDate ? 'Expires ' + endDate  : false }</div>
		</Cell>);
	}
}

export default class OrderList extends Component {

	constructor (props) {
    super(props);
  }

	render () {

		let orders = keyedObjToArr(this.props.orders);

		return (
			<Table
				className="table ui-list"
				sortable={['customer','status',]}
				filterable={['customer','status']}
				hideFilterInput
				filterBy={this.props.filterBy}
				noDataText=" No orders found"
				defaultSort='customer'
			>
				<Thead className="list-row header">
				<Th className="list-cell avatar-cell" column="orderStatus">&nbsp;</Th>
				<Th className="list-cell" column="customer">Customer</Th>
				<Th className="list-cell" column="products">Products</Th>
				<Th className="list-cell" column="status" >Status</Th>
				<Th className="list-cell align-center narrow" column="edit">Edit</Th>
				</Thead>
				{orders.map((orderItem, index) => {
                    let customer;

                    if(orderItem.customer) {
                        customer = this.props.customers[orderItem.customer];
                    }
                    else{
                    	return;
					}

                    let startDate = orderItem.startDate ? moment(orderItem.startDate).format('MM/DD/YYYY') : '';
                    let status = orderItem.status ? orderItem.status.charAt(0).toUpperCase() + orderItem.status.slice(1) : '';

					return (
						<Tr className="list-row" key={index}>
							<Td className="avatar-cell" column="orderStatus">
								<AvatarCell
									item={orderItem}
									value={orderItem.status}
								/>
							</Td>
							<Td column="customer" value={customer.name}>
								<CustomerCell
									item={orderItem}
									customer={customer}
									products={this.props.products}
									customers={this.props.customers}
								/>
							</Td>
							<Td column="products">
								<ProductsCell
									item={orderItem}
								/>
							</Td>
							<Td column="status" value={status + ' ' + startDate}>
								<StatusCell
									item={orderItem}
								/>
							</Td>
							<Td className="list-cell align-center narrow" column="edit">
								<ActionCell
									item={orderItem}
									edit={this.props.editOrder.bind(this)}
									delete={this.props.deleteOrder.bind(this)}
								/>
							</Td>
						</Tr>
					);
				}, this)}
			</Table>
		);
	}
}




// WEBPACK FOOTER //
// ./js/components/OrderList.js